"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NULL_BYTES = '0x';
//# sourceMappingURL=constants.js.map